import { Edge, EdgeProps } from '@/components/layout/Edge';
import { Component } from '@/types/component';

export const MabraEdge: Component<EdgeProps> = ({ children }) => {
  return <Edge>{children}</Edge>;
};

export default MabraEdge;
